import React from 'react';
import PropTypes from "prop-types";
import Typography from "@mui/material/Typography";
import { withStyles } from "@mui/styles";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import { toast } from "react-toastify";
import FormControlLabel from '@mui/material/FormControlLabel';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import classNames from 'classnames';
import Checkbox from "@mui/material/Checkbox";
import TextareaAutosize from 'react-autosize-textarea';
import DialogContentText from "@mui/material/DialogContentText";
import { withTranslation } from 'react-i18next';


const styles = theme => ({
  root: {
    width: "100%"
  },
  waitIcon: {
    position: 'absolute',
    top: '40%',
    left: '40%',
    zIndex: '99999999'
    // opacity: 0.5
  },
  imgProperty: {
    height: '100px'
  }
});
class Manualconsultation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      DialogOpen: this.props.detailDialogOpen,
      isButtonDisabled: false,
      PatietPrescriptionData: '',
      consultnotes: '',
      ReleaseOrder: false,
      ReleaseOrderOpen: false,
      orderNotReleasedOpen: false,
      UserId: '',
      UserName: '',
    }
  }
  componentWillMount() {
    this.getPrescriptionDetailByPickupCode(this.props.pickupCode);
    this.getManualReleaseOrderDetailByPickupCode(this.props.pickupCode);
    fetch(process.env.REACT_APP_BASEURL + 'users/' + JSON.parse(sessionStorage.getItem('user')).username, {
      method: 'GET',
      withCredentials: true,
      headers: {
        'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
        'Content-Type': 'application/json'
      }
    })
      .then(response => {
        try {
          return response.text();
        } catch (error) {
          return null;
        }
      })
      .then(uData => {
        if (uData) {
          const userData = JSON.parse(uData);
          this.setState({ UserId: userData[0].id, UserName: userData[0].name })
        }
      });
  }
  handleClose = () => {
    this.setState({ DialogOpen: false, orderNotReleasedOpen: false });
    this.props.onPopupClose();
  }
  getPrescriptionDetailByPickupCode = (pickupcode) => {
    fetch(process.env.REACT_APP_BASEURL + 'getprescriptiondetailbypucode/' + pickupcode, {
      method: 'GET',
      withCredentials: true,
      headers: {
        'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
        'Content-Type': 'application/json'
      }
    })
      .then(response => {
        try {
          return response.text();
        } catch (error) {
          return null;
        }
      })
      .then(pData => {
        if (pData) {
          let data = JSON.parse(pData);
          this.setState({ PatietPrescriptionData: data })
        }
      });
  }
  createRow = () => {
    const { classes } = this.props;
    let Data = this.state && this.state.PatietPrescriptionData;
    if (Data) {
      return (Data.map((val, idx) => {
        return (<TableRow>
          <TableCell className={classNames(classes.removePadding)} style={{ padding: 0 }}>
            {val.rx_no}
          </TableCell>
          <TableCell className={classNames(classes.removePadding)} style={{ padding: 0 }}>
            {val.drug_name}
          </TableCell>
          <TableCell className={classNames(classes.AmountAlignment)} style={{ padding: 0 }}>
            {val.doseage_form}
          </TableCell>
          <TableCell className={classNames(classes.AmountAlignment)} style={{ padding: 0 }}>
            {val.qty}
          </TableCell>
        </TableRow>)
      }))
    }
  }
  handleChangeConsultNotes = event => {
    event.preventDefault && event.preventDefault();
    this.setState({ consultnotes: event.target.value });
  };
  handleReleaseOrder = () => {
    this.setState({ ReleaseOrderOpen: true });
  };
  releaseorderaccept = () => {
    this.setState({ ReleaseOrder: !this.state.ReleaseOrder });
    var statusObj = {
      consult_start_date: new Date(),
      consult_end_date: new Date(),
      pickup_code: this.props.pickupCode,
      user_name: this.props.selectedObject.FirstName + this.props.selectedObject.LastName,
      call_duration: '00:00:00',
      user_id: this.state.UserId,
      consultation_name: this.state.UserName,
      Status: 'Offline',
      accounts_id: this.props.accountDetails.id,
      store_name: this.props.accountDetails.name,
      box_id: this.props.boxId,
      kiosk_name: this.props.pharmacyDetails.name,
      consultation_notes: this.state.consultnotes,
      is_releaseorder: true
    }
    fetch(process.env.REACT_APP_BASEURL + 'saveuserconsult', {
      method: 'post',
      withCredentials: true,
      headers: {
        'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(statusObj)
    })
      .then(response => {
        try {
          return response.text();
        } catch (error) {
          return null;
        }
      })
      .then(uData => {
        this.state.orderNotReleasedOpen ? this.savemanualuserConsult() : this.setState({ ReleaseOrderOpen: false });
        toast.success(this.props.t('Toast.Success.OrderReleased'));
        window.socket &&
          window.socket.emit &&
          window.socket.emit('isOrderReleasedFromDeliveryPrescription', this.props.pickupCode);
      });
  };
  handleCloseRleaseOrder = () => {
    this.setState({ ReleaseOrderOpen: false });
  };
  savemanualuserConsult = () => {
    let isConsultRequired = false;
    this.props
      && this.props.searchedRxItems
      && this.props.searchedRxItems.length > 0
      && this.props.searchedRxItems.map((i) => {
        if (i.is_consultrequire === true) {
          isConsultRequired = true;
        }
        return false;
      });
    var statusObj = {
      consult_start_date: new Date(),
      consult_end_date: new Date(),
      pickup_code: this.props.pickupCode,
      user_name: this.props.selectedObject.FirstName + this.props.selectedObject.LastName,
      call_duration: '00:00:00',
      user_id: this.state.UserId,
      consultation_name: this.state.UserName,
      Status: 'Offline',
      accounts_id: this.props.accountDetails.id,
      store_name: this.props.accountDetails.name,
      box_id: this.props.boxId,
      kiosk_name: this.props.pharmacyDetails.name,
      consultation_notes: this.state.consultnotes,
      is_releaseorder: this.state.ReleaseOrder,
      isConsultRequired,
    }
    fetch(process.env.REACT_APP_BASEURL + 'saveuserconsult', {
      method: 'post',
      withCredentials: true,
      headers: {
        'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(statusObj)
    })
      .then(response => {
        try {
          return response.text();
        } catch (error) {
          return null;
        }
      })
      .then(uData => {
        toast.success(this.props.t('Toast.Success.ConsultComplete'));
        this.handleClose();
      });
  };
  getManualReleaseOrderDetailByPickupCode = (pickupcode) => {
    fetch(process.env.REACT_APP_BASEURL + 'getmanualreleaseorderdetailbypickupcode/' + pickupcode, {
      method: 'GET',
      withCredentials: true,
      headers: {
        'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
        'Content-Type': 'application/json'
      }
    })
      .then(response => {
        try {
          return response.text();
        } catch (error) {
          return null;
        }
      })
      .then(pData => {
        if (pData) {
          let data = JSON.parse(pData);
          if (data && data.length > 0) {
            this.setState({ ReleaseOrder: data[0].is_releaseorder });
            this.setState({ consultnotes: data[0].consultation_notes });
          }
        }
      });
  }
  render() {
    const { classes, t } = this.props;
    return (
      <div>
        <Dialog
          open={this.state.DialogOpen || false}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          fullWidth={true}
          maxWidth={'md'}
        >
          <div className={classes.paddedBoxDivEdit}>
            <DialogTitle id="form-dialog-title">{t("Assign.ManualConsult.ConsultRoom")} <span style={{ color: '#0a5d66', fontWeight: 500, textDecoration: 'none ', fontSize: '1.5rem' }}>{this.props.pickupCode}</span></DialogTitle>
            <div style={{ display: 'flex', flexDirection: 'row' }}>
              <div style={{ width: '50%' }}>
                <DialogContent>
                  <Typography variant="title" color="inherit" noWrap className={classes.flex}> Consultation Notes</Typography>
                  <TextareaAutosize
                    style={{ minHeight: 130, maxHeight: 130, width: '100%', boxSizing: 'border-box', border: '1px solid rgba(224, 224, 224, 1)', fontSize: '0.8125rem', fontWeight: '400', padding: '10px', fontFamily: 'Roboto,Helvetica,Arial,sans-serif', color: 'rgba(0, 0, 0, 0.87)' }}
                    onBlur={this.handleChangeConsultNotes}
                    onChange={this.handleChangeConsultNotes}
                    label={t("Assign.ManualConsult.ConsultNotes")}
                    defaultValue={this.state.consultnotes}
                    value={this.state.consultnotes}
                  />
                </DialogContent>
              </div>
              <div style={{ width: '50%' }}>
                <DialogContent>
                  <Table className={classes.table}>
                    <TableHead className={classNames(classes.TableHead)}>
                      <TableRow>
                        <TableCell className={classNames(classes.NameCellWidth)} style={{ padding: 0 }}>
                          <b>{t("Assign.ManualConsult.RxHash")}</b>
                        </TableCell>
                        <TableCell className={classNames(classes.NameCellWidth)} style={{ padding: 0 }}>
                          <b>{t("Assign.ManualConsult.DrugName")}</b>
                        </TableCell>
                        <TableCell className={classNames(classes.AmountCell)} style={{ padding: 0 }}>
                          <b>{t("Assign.ManualConsult.Dose")}</b>
                        </TableCell>
                        <TableCell className={classNames(classes.AmountCell)} style={{ padding: 0 }}>
                          <b>{t("Assign.ManualConsult.Qty")}</b>
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {this.createRow()}
                    </TableBody>
                  </Table>
                </DialogContent>
              </div>
            </div>
            <div>
              <DialogContent>
                <div>
                  <FormControlLabel
                    label={t("Assign.ManualConsult.ReleaseOrder")}
                    control={
                      <Checkbox
                        disabled={this.state.ReleaseOrder}
                        checked={this.state.ReleaseOrder}
                        onChange={() => this.handleReleaseOrder('')}
                        value={this.state.ReleaseOrder}
                      />
                    }
                    style={{ marginLeft: '0px', marginRight: '0px' }}
                  />
                </div>
              </DialogContent>
            </div>
            <DialogActions>
              <Button
                type="submit"
                disabled={this.state.isButtonDisabled}
                color="primary"
                onClick={
                  this.state.ReleaseOrder ? this.savemanualuserConsult : () => this.setState({ orderNotReleasedOpen: true })}>
                {t("Assign.ManualConsult.CompleteConsult")}
              </Button>
              <Button onClick={this.handleClose} color="primary">
                {t("Assign.ManualConsult.Close")}
              </Button>
            </DialogActions>
          </div>
        </Dialog>
        <Dialog
          open={this.state.ReleaseOrderOpen}
          onClose={this.handleCloseRleaseOrder}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <div className={classes.DialogBack} style={{ background: 'linear-gradient(155deg, #ce907b 0%,#ffcfa6 90%)' }}>
            {/* <DialogTitle id="alert-dialog-title">Consult Request</DialogTitle> */}
            <DialogContent>
              <DialogContentText className={classes.DialogText} style={{ color: '#387371', textAlign: 'center' }}>
                {t("Assign.ManualConsult.AreYouSureToReleaseOrder")}
              </DialogContentText>
            </DialogContent>
            <DialogActions className={classes.ButtonAlign} style={{ justifyContent: 'center' }}>
              <Button
                className={classes.buttonFace}
                style={{ color: '#387371' }}
                onClick={this.releaseorderaccept}>
                {t("Assign.ManualConsult.Yes")}
              </Button>
              <Button
                disabled={this.state.isButtonDisabled}
                style={{ color: '#387371' }}
                className={classes.buttonFace}
                onClick={this.handleCloseRleaseOrder}>
                {t("Assign.ManualConsult.No")}
              </Button>
            </DialogActions>
          </div>
        </Dialog>
        <Dialog
          open={this.state.orderNotReleasedOpen}
          onClose={this.handleConsultClose}
          aria-labelledby='alert-dialog-title'
          aria-describedby='alert-dialog-description'>
          <DialogContent className={classes.DialogContentWrap}>
            <DialogContentText className={classes.DialogText}>
              {t("Assign.ManualConsult.ConfirmToReleaseOrder")}
            </DialogContentText>
          </DialogContent>
          <DialogActions className={classes.ButtonAlign}>
            <Button
              className={classes.primaryButton}
              onClick={this.releaseorderaccept}>
              {t("Assign.ManualConsult.ReleaseOrder")}
            </Button>
            <Button
              disabled={this.state.isButtonDisabled}
              className={classes.primaryButton}
              onClick={this.savemanualuserConsult}>
              {t("Assign.ManualConsult.CompleteConsult")}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}
Manualconsultation.propTypes = {
  classes: PropTypes.object.isRequired
};
export default withStyles(styles, { withTheme: true })(withTranslation()(Manualconsultation));



// WEBPACK FOOTER //
// ./src/components/assign-prescriptions/Manual-consultation.js